var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.SkinComponent,{tag:"component",attrs:{"code":_vm.code},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }